// removed by extract-text-webpack-plugin
module.exports = {"root":"_313jFh6xZvzsPFEGC3Flwz","content":"GyJWzs9FTdw6_EvyKpzC9","extraMargin":"_2uuP3KEBggC-96KQSzoLv0","more":"_1s-RLI1u0moc2u6_7lT3tC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/zippy.scss
// module id = 1322
// module chunks = 0